import axios from 'axios';
import { URI } from '../helpers/constans';

type AddMemorableMomentPayload = {
  qdosItemId: string;
  qdosEventId: string;
  qdosPostId: string;
  alternativeId?: string;
  mediaType?: string;
  imageId?: string;
  videoUrl?: string;
  description?: string;
  eventTitle?: string;
};

export const addToShare = (payload: {
  qdosItemId: string;
  qdosEventId: string;
  shareType: 'team' | 'fan';
}) => {
  return axios.post(`${URI}/share/items`, payload);
};

export const getTeamShare = (eventId: string) => {
  return axios.get(`${URI}/share/events/${eventId}/team`);
};

export const getFanShare = (eventId: string) => {
  return axios.get(`${URI}/share/events/${eventId}/fan`);
};

export const getTeamShareHistory = () => {
  return axios.get(`${URI}/share/events/team/history`);
};

export const getFanShareHistory = () => {
  return axios.get(`${URI}/share/events/fan/history`);
};

export const likeShareItem = (id: string) => {
  return axios.post(`${URI}/share/items/${id}/like`);
};

export const unlikeShareItem = (id: string) => {
  return axios.delete(`${URI}/share/items/${id}/like`);
};

export const removeShareItem = (id: string) => {
  return axios.delete(`${URI}/share/items/${id}`);
};

export const addMemorableMoment = (payload: AddMemorableMomentPayload) => {
  return axios.post(`${URI}/memorable-moments`, payload);
};

export const getMemorableMoments = () => {
  return axios.get(`${URI}/memorable-moments`);
};

export const deleteMemorableMoment = (id: string) => {
  return axios.delete(`${URI}/memorable-moments/${id}`);
};
